<template>
  <div v-if="maxRangeEventReservation" v-show="items && items.length > 1" style="padding: 10px;">
    <v-select
          :items="items"
          label="Días a reservar"
          outlined
          hide-details
          dense
          @change="onChange"
        />
  </div>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    activityID: {
      type: String,
      required: true
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    maxRangeEventReservation: null,
    items: []
  }),
  watch: {
    activityID () {
      this.prepareData()
    },
  },
  mounted () {
    this.prepareData()
  },
  methods: {
    prepareData () {
      const urlBase = process.env.VUE_APP_API_URL_DTOUCH
      const url = `${window.location.protocol}//${urlBase}/v1/public/cm/activities/${this.activityID}`
      axios.get(url)
        .then(response => {
          const aux = response.data.shift()
          this.maxRangeEventReservation = aux.MaxRageEventReservation
          if (this.maxRangeEventReservation) {
            for (let i = 1 ; i <= this.maxRangeEventReservation; i ++) {
              this.items.push(i)
            }
          } else {
            this.onChange(null)
          }
        })
    },
  },
}
</script>


